module.exports = __webpack_public_path__ + "woff/am-icon-font.1e348c.woff";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/am-icon-font.woff
 ** module id = 314
 ** module chunks = 12
 **/